<template>
  <div>
    <h3>Welcome</h3>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
</style>